// D:\VirtuoSys\app\src\routes\_authenticated\super-admin-blog-preview.tsx
import { createFileRoute, redirect } from '@tanstack/react-router';
import { useAuthStore } from '@/stores/authStore';
import BlogPreviewView from '@/views/super-admin/blog_preview';

export const Route = createFileRoute('/_authenticated/super-admin-blog-preview')({
  component: BlogPreviewView,
  beforeLoad: async () => {
    const auth = useAuthStore.getState().auth;

    if (!auth.accessToken || !auth.user) {
      throw redirect({ to: '/auth/login' });
    }

    if (auth.user.role !== 'Super Admin' && auth.user.role_name !== 'Super Admin') {
      throw redirect({ to: '/dashboard' });
    }
  },
});
